export const SET_GROUP_ORDER_PAGE = 'SET_GROUP_ORDER_PAGE'
export const CLEAR_GROUP_ORDER_PAGE = 'CLEAR_GROUP_ORDER_PAGE'

//change vairable name
export const clearGroupOrderPage = () => ({ type: CLEAR_GROUP_ORDER_PAGE })
export const setGroupOrderPage = (groupOrderPage) => ({
  type: SET_GROUP_ORDER_PAGE,
  groupOrderPage,
})
